

import PreAlert from './components/PreAlert';
import Login from './components/Login';
import CancelBookingPage from './views/CancelBookingPage';
import { Routes, Route, BrowserRouter } from "react-router-dom"
import AdminLayout from "./layouts/Admin";


function App() {

  return (
    <BrowserRouter>
      <Routes>
          <Route exact path="/" element={<PreAlert/>} />
          <Route path="/cancel-booking/:docId/:token" element={<CancelBookingPage/>} />
          <Route path="/sign-in" element={<Login/>} />
          <Route path="/super-admin/*" element={<AdminLayout/>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
